import { LogLevel, PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

export const loginRequest = {
  scopes: [
    `${process.env.REACT_APP_DATAVERSE_URL.replace('/api/data/v9.2', '')}/user_impersonation`,
    "User.Read",
    "GroupMember.Read.All"
  ],
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphGroupsEndpoint: "https://graph.microsoft.com/v1.0/me/memberOf",
};

export const securityGroups = {
  // Read-only calendar access
  calendarViewers: [
    "d26b0b49-43dc-4f85-949d-aa1ba5b39aa7",
    "a2ecb72f-0fc1-406a-a870-7b81786d6928",
    "3f2e1ab2-11c8-4b39-bce1-f4c0efb163a3"
  ],
  // Edit individual sessions on the live calendar + view administration page
  calendarEditors: [
    "e23ce2de-87cf-4ce0-b5e2-e1552b073f01"
  ],
  // Open the schedule generator, create/edit/save drafts (cannot publish)
  scheduleManagers: [
    "1e325622-2e16-42ab-ac00-f53abe6f2ef8"
  ],
  // Everything scheduleManagers can do PLUS publish drafts to Dataverse / Power Apps
  scheduleAdmins: [
    "7ab65e50-bf48-4ecb-a0e6-dfd734234b05"
  ],
  // IT Management Team — full access to everything (calendar editor + admin + publish)
  itAdmins: [
    "17803eb8-0876-4bc6-b58b-4290ef54ec5e"
  ]
};

// Derive role flags from a list of group IDs the user belongs to.
// Single source of truth — used by App.js and any other client-side gate.
export const derivePermissions = (userGroupIds = []) => {
  const has = (groupList) => groupList.some(id => userGroupIds.includes(id));
  const isITAdmin = has(securityGroups.itAdmins);
  const isScheduleAdmin = isITAdmin || has(securityGroups.scheduleAdmins);
  const isScheduleManager = isScheduleAdmin || has(securityGroups.scheduleManagers);
  const isCalendarEditor = isITAdmin || has(securityGroups.calendarEditors);
  const isCalendarViewer = isCalendarEditor || isScheduleManager || has(securityGroups.calendarViewers);

  return {
    isITAdmin,
    isScheduleAdmin,    // can publish drafts to Dataverse / PA
    isScheduleManager,  // can open generator and save drafts
    isCalendarEditor,   // can edit the calendar and view Administration
    isCalendarViewer,   // can view the calendar
    canPublish: isScheduleAdmin,
    canEditDrafts: isScheduleManager,
    canViewAdministration: isCalendarEditor
  };
};

// Create and export the MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);
